import { render, staticRenderFns } from "./goods-returns-table.vue?vue&type=template&id=762b2582"
import script from "./goods-returns-table.vue?vue&type=script&lang=js"
export * from "./goods-returns-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports